import BuildIcon from "@mui/icons-material/Build";

import { ThinkingIndicator } from "@/shared/components";
import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { ChatToolUseContent } from "@/shared/domain/chat/ChatRecord";

import styles from "./AssistantToolUseContent.module.css";

interface AssistantToolUseContentProps {
  toolUse: ChatToolUseContent;
}

const AssistantToolUseContent = ({ toolUse }: AssistantToolUseContentProps) => {
  return (
    <div className={styles.indentedContainer}>
      <div className={styles.messageContainer}>
        <ThinkingIndicator size="small" />
        <div className={styles.textAndIconContainer}>
          <BuildIcon className={styles.buildIcon} />
          <RobotoTypography className={styles.text}>
            Using Tool <b>{toolUse.tool_name}</b>
          </RobotoTypography>
        </div>
      </div>
    </div>
  );
};

export { AssistantToolUseContent };
